import { deserializeSuperjson, SuperJSONResult } from '@lib/superjson';
import { ViewTeamsResponse } from '@snap-types/actions/view-teams';

import type { API } from '../api';

export class AdminTeamService {
  constructor(private api: API) {}

  getAll = async () => {
    return deserializeSuperjson<ViewTeamsResponse>(
      await this.api.get<SuperJSONResult>('/admin/teams'),
    );
  };
}
